import { Button } from 'components/atoms';
import LabelFormStep from 'components/templates/label-form-step/LabelFormStep';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { PiCheck } from 'react-icons/pi';
import { ILabelForm, LABEL_STATUS } from 'services/labels/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

const LabelFinalStep = () => {
  const { t } = useTranslation();
  const formik = useFormikContext<ILabelForm>();

  const onSubmit = async (status: LABEL_STATUS) => {
    await formik.setFieldValue('labelStatus', status);
    // formik.handleSubmit();
    await formik.submitForm();
  };

  return (
    <LabelFormStep
      header={t('label.form.final.header')}
      description={t('label.form.final.description')}>
      <Button
        variant={BUTTON_VARIANT.submit}
        fullWidth
        onClick={() => onSubmit(LABEL_STATUS.DuringVerification)}
        disabled={formik.status?.isLoading}
        isLoading={formik.status?.isPending}>
        <Button.Text text={t('button.send-to-verification')} />
        <Button.Icon icon={<PiCheck />} />
      </Button>
    </LabelFormStep>
  );
};

export default LabelFinalStep;
